import { Inject, Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { ENVIRONMENT } from 'src/app/constants';
import { Environment } from 'src/app/types';

@Injectable()
export class ApiConfigurationInterceptor implements HttpInterceptor {
  constructor(@Inject(ENVIRONMENT) private environment: Environment) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    if (request.url.match(/(?::\/\/)/)) {
      return next.handle(request);
    }
    const clonedRequest = request.clone({
      url: `${this.environment.api}${request.url}`
    });
    return next.handle(clonedRequest);
  }
}
